import { ALIGN_ITEMS, AUTO_FLOW_TYPES, BUILDING_BLOCK_TYPES, CONTAINER_TYPES, GAP_TYPES, GRID_NODE_TYPES, ROW_COLUMN_SIZE_TYPES, STACK_DIRECTIONS, UNITS } from './constants';
import { AutoRowOrColumnSizeTypename, ContainerTypename, GridContainerLayoutTypename, StackContainerLayoutTypename, UnifiedGapTypename, MinMaxRowOrColumnSizeTypename, SizedContentRowOrColumnSizeTypename, PegboardContainerLayoutTypename } from '../../__generated__/chirp/com/hubspot/content/grid/layouts/rpc/GridLayoutsRpc';
import { generateUniqueId } from './utils';
export const DEFAULT_ROW_SIZE_DEFINITION = {
  __typename: MinMaxRowOrColumnSizeTypename,
  type: ROW_COLUMN_SIZE_TYPES.MINMAX,
  min: {
    value: 75,
    units: 'PX',
    keywordOnly: false
  },
  max: {
    units: ROW_COLUMN_SIZE_TYPES.AUTO,
    value: undefined,
    keywordOnly: true
  }
};
export const DEFAULT_PEGBOARD_ROW_SIZE_DEFINITION = {
  __typename: MinMaxRowOrColumnSizeTypename,
  type: ROW_COLUMN_SIZE_TYPES.MINMAX,
  min: {
    value: 2,
    units: UNITS.VW,
    keywordOnly: false
  },
  max: {
    units: ROW_COLUMN_SIZE_TYPES.AUTO,
    value: undefined,
    keywordOnly: true
  }
};
export const DEFAULT_PEGBOARD_COLUMN_SIZE_DEFINITION = {
  __typename: MinMaxRowOrColumnSizeTypename,
  type: ROW_COLUMN_SIZE_TYPES.MINMAX,
  min: {
    value: 0,
    units: UNITS.PX,
    keywordOnly: false
  },
  max: {
    value: 1,
    units: UNITS.FRACTION,
    keywordOnly: false
  }
};
export const DEFAULT_COLUMN_SIZE_DEFINITION = {
  __typename: SizedContentRowOrColumnSizeTypename,
  type: ROW_COLUMN_SIZE_TYPES.SIZED,
  size: {
    value: 1,
    units: UNITS.FRACTION
  }
};
export function createGridContainer(buildingBlockType) {
  switch (buildingBlockType) {
    case BUILDING_BLOCK_TYPES.HORIZONTAL_STACK:
      {
        return {
          __typename: ContainerTypename,
          type: GRID_NODE_TYPES.CONTAINER,
          children: [],
          layout: {
            layout: {
              default: {
                __typename: StackContainerLayoutTypename,
                type: CONTAINER_TYPES.STACK,
                direction: STACK_DIRECTIONS.HORIZONTAL
              }
            }
          },
          id: generateUniqueId('container-'),
          styles: {
            breakpointStyles: {
              default: {
                alignItems: ALIGN_ITEMS.CENTER,
                gap: {
                  type: GAP_TYPES.UNIFIED,
                  size: {
                    value: 8,
                    units: UNITS.PX
                  },
                  __typename: UnifiedGapTypename
                },
                backgroundLayers: []
              }
            }
          }
        };
      }
    case BUILDING_BLOCK_TYPES.VERTICAL_STACK:
      {
        return {
          __typename: ContainerTypename,
          type: GRID_NODE_TYPES.CONTAINER,
          layout: {
            layout: {
              default: {
                __typename: StackContainerLayoutTypename,
                type: CONTAINER_TYPES.STACK,
                direction: STACK_DIRECTIONS.VERTICAL
              }
            }
          },
          children: [],
          id: generateUniqueId('container-'),
          styles: {
            breakpointStyles: {
              default: {
                alignItems: ALIGN_ITEMS.CENTER,
                gap: {
                  type: GAP_TYPES.UNIFIED,
                  size: {
                    value: 8,
                    units: UNITS.PX
                  },
                  __typename: UnifiedGapTypename
                },
                backgroundLayers: []
              }
            }
          }
        };
      }
    case BUILDING_BLOCK_TYPES.TABLE:
      {
        return {
          __typename: ContainerTypename,
          type: GRID_NODE_TYPES.CONTAINER,
          children: Array.from({
            length: 4
          }, () => ({
            __typename: ContainerTypename,
            type: GRID_NODE_TYPES.CONTAINER,
            children: [],
            layout: {
              layout: {
                default: {
                  __typename: StackContainerLayoutTypename,
                  type: CONTAINER_TYPES.STACK,
                  direction: STACK_DIRECTIONS.HORIZONTAL
                }
              }
            },
            id: generateUniqueId('container-'),
            styles: {
              breakpointStyles: {
                default: {
                  alignItems: ALIGN_ITEMS.CENTER,
                  gap: {
                    type: GAP_TYPES.UNIFIED,
                    size: {
                      value: 8,
                      units: UNITS.PX
                    },
                    __typename: UnifiedGapTypename
                  },
                  backgroundLayers: []
                }
              }
            }
          })),
          layout: {
            layout: {
              default: {
                __typename: GridContainerLayoutTypename,
                type: CONTAINER_TYPES.GRID,
                columns: Array.from({
                  length: 2
                }, () => ({
                  size: {
                    __typename: SizedContentRowOrColumnSizeTypename,
                    type: ROW_COLUMN_SIZE_TYPES.SIZED,
                    size: {
                      value: 1,
                      units: UNITS.FRACTION
                    }
                  }
                })),
                rows: Array.from({
                  length: 2
                }, () => ({
                  size: DEFAULT_ROW_SIZE_DEFINITION
                })),
                autoRows: Array.from({
                  length: 2
                }, () => ({
                  size: {
                    __typename: AutoRowOrColumnSizeTypename,
                    type: ROW_COLUMN_SIZE_TYPES.AUTO
                  }
                }))
              }
            }
          },
          id: generateUniqueId('container-'),
          styles: {
            breakpointStyles: {
              default: {
                gap: {
                  type: GAP_TYPES.UNIFIED,
                  size: {
                    units: UNITS.PX,
                    value: 16
                  },
                  __typename: UnifiedGapTypename
                },
                backgroundLayers: []
              }
            }
          }
        };
      }
    case BUILDING_BLOCK_TYPES.PEGBOARD:
      {
        return {
          __typename: ContainerTypename,
          type: GRID_NODE_TYPES.CONTAINER,
          children: [],
          layout: {
            layout: {
              default: {
                __typename: PegboardContainerLayoutTypename,
                type: CONTAINER_TYPES.PEGBOARD,
                columns: Array.from({
                  length: 24
                }, () => ({
                  size: DEFAULT_PEGBOARD_COLUMN_SIZE_DEFINITION
                })),
                rows: Array.from({
                  length: 7
                }, () => ({
                  size: DEFAULT_PEGBOARD_ROW_SIZE_DEFINITION
                }))
              }
            }
          },
          id: generateUniqueId('container-'),
          styles: {
            breakpointStyles: {
              default: {
                gap: {
                  type: GAP_TYPES.UNIFIED,
                  size: {
                    units: UNITS.PX,
                    value: 11
                  },
                  __typename: UnifiedGapTypename
                },
                backgroundLayers: []
              }
            }
          }
        };
      }
    default:
      {
        throw new Error(`Unexpected building block type '${buildingBlockType}' reached`);
      }
  }
}
export const createBaseHorizontalStackContainerWithStyles = styles => ({
  __typename: ContainerTypename,
  type: GRID_NODE_TYPES.CONTAINER,
  children: [],
  layout: {
    layout: {
      default: {
        __typename: StackContainerLayoutTypename,
        type: CONTAINER_TYPES.STACK,
        direction: STACK_DIRECTIONS.HORIZONTAL
      }
    }
  },
  id: generateUniqueId('container-'),
  styles: {
    breakpointStyles: {
      default: Object.assign({
        backgroundLayers: []
      }, styles)
    }
  }
});
export const createBaseGridTableContainerWithStyles = (rows, columns, styles) => ({
  __typename: ContainerTypename,
  type: GRID_NODE_TYPES.CONTAINER,
  children: [],
  layout: {
    layout: {
      default: {
        __typename: GridContainerLayoutTypename,
        type: CONTAINER_TYPES.GRID,
        rows: Array.from({
          length: rows
        }, () => ({
          size: DEFAULT_ROW_SIZE_DEFINITION
        })),
        columns: Array.from({
          length: columns
        }, () => ({
          size: {
            __typename: SizedContentRowOrColumnSizeTypename,
            type: ROW_COLUMN_SIZE_TYPES.SIZED,
            size: {
              value: 1,
              units: UNITS.FRACTION
            }
          }
        })),
        autoFlow: AUTO_FLOW_TYPES.ROW,
        autoRows: [{
          size: {
            __typename: AutoRowOrColumnSizeTypename,
            type: ROW_COLUMN_SIZE_TYPES.AUTO
          }
        }]
      }
    }
  },
  id: generateUniqueId('container-'),
  styles: {
    breakpointStyles: {
      default: Object.assign({
        backgroundLayers: []
      }, styles)
    }
  }
});
export const createStackContainerWithBlankChildren = (stackType, numberOfChildren, flexGrowOfChildren) => {
  const stackContainer = createGridContainer(stackType === STACK_DIRECTIONS.HORIZONTAL ? BUILDING_BLOCK_TYPES.HORIZONTAL_STACK : BUILDING_BLOCK_TYPES.VERTICAL_STACK);
  // for both horizontal and vertical stacks, creating horizontal stack children
  stackContainer.children = Array.from({
    length: numberOfChildren
  }, (_, i) => createBaseHorizontalStackContainerWithStyles({
    flexGrow: flexGrowOfChildren[i]
  }));
  return stackContainer;
};
export const createGridContainerWithBlankCells = (rows, columns) => {
  const gridContainer = createBaseGridTableContainerWithStyles(rows, columns, {
    gap: {
      type: GAP_TYPES.UNIFIED,
      size: {
        value: 8,
        units: UNITS.PX
      },
      __typename: UnifiedGapTypename
    }
  });
  gridContainer.children = Array.from({
    length: rows * columns
  }, () => createGridContainer(BUILDING_BLOCK_TYPES.HORIZONTAL_STACK));
  return gridContainer;
};
export const createSection = () => {
  return {
    type: GRID_NODE_TYPES.SECTION,
    id: generateUniqueId('section-'),
    styles: {
      breakpointStyles: {}
    },
    child: createGridContainer(BUILDING_BLOCK_TYPES.HORIZONTAL_STACK)
  };
};
export const createBlankGridLayoutSection = props => {
  let containerChild;
  switch (props.type) {
    case 'STACK':
      containerChild = createStackContainerWithBlankChildren(props.direction, props.childrenCount, props.flexGrowOfChildren);
      break;
    case 'GRID':
      containerChild = createGridContainerWithBlankCells(props.rows, props.columns);
      break;
    case 'PEGBOARD':
      containerChild = createGridContainer(BUILDING_BLOCK_TYPES.PEGBOARD);
      break;
    default:
      throw new Error(`Unexpected section type reached; ${props}`);
  }
  return {
    type: GRID_NODE_TYPES.SECTION,
    id: generateUniqueId('section-'),
    styles: {
      breakpointStyles: {}
    },
    child: containerChild
  };
};